import { render, staticRenderFns } from "./host-set-industryType.vue?vue&type=template&id=35ad7795&scoped=true&"
import script from "./host-set-industryType.vue?vue&type=script&lang=js&"
export * from "./host-set-industryType.vue?vue&type=script&lang=js&"
import style0 from "./host-set-industryType.vue?vue&type=style&index=0&id=35ad7795&scoped=true&lang=scss&"
import style1 from "./host-set-industryType.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ad7795",
  null
  
)

export default component.exports